import { Progress } from '@/components/ui/progress';
import { TooltipStatus } from '../tooltip-status';
import { Typography } from '../typography';
import { cn } from '@/lib';
import { StatusCase, StatusTypes } from '@/interfaces';
import clsx from 'clsx';
import { END_STATUSES_CASE } from '@/const/cases';

interface Props {
	percent: number;
	stepName: StatusCase;
	status: StatusTypes;
}

export const CustomProgressBar: React.FC<Props> = ({
	status,
	stepName,
	percent,
}) => {
	return (
		<div className="flex items-center gap-3">
			<Progress
				value={percent}
				aria-labelledby="Progress bar for case status"
				classNameIndicator={clsx({
					'bg-gray-70': END_STATUSES_CASE.includes(status),
					'bg-main-blue': !END_STATUSES_CASE.includes(status),
				})}
				classNameRoot={clsx({
					'bg-gray-30': END_STATUSES_CASE.includes(status),
				})}
			>
				<TooltipStatus
					trigger={
						<div
							className={cn('absolute top-[-7px] h-5 w-5 rounded-full', {
								'bg-gray-70': END_STATUSES_CASE.includes(status),
								'bg-main-blue': !END_STATUSES_CASE.includes(status),
							})}
							style={{ left: `calc(${percent || 0}% - 10px)` }}
						/>
					}
					stepName={status === 'Declined' ? 'Application declined' : stepName}
					status={status}
					percent={percent}
				/>
			</Progress>
			{!END_STATUSES_CASE.includes(status) ? (
				<Typography
					type="regular-14"
					text={`${percent}%`}
					className="opacity-60"
				/>
			) : (
				<div className="h-5" />
			)}
		</div>
	);
};
